import { createFileRoute } from '@tanstack/react-router'
import { requireTrainer } from '@/lib/auth-guards'
import { TrainerStudentsPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainer/students')({
  beforeLoad: async () => {
    await requireTrainer()
  },
  component: TrainerStudentsPage,
})
